import React from "react";

import { useNavigate } from "react-router-dom";
import defaultuser from "../../../assets/images/defaultuser.jpg";
import deleteIcon from "../../../assets/icons/deleteIcon.svg";
import StarRating from "@/components/StarRating/StarRating";
import { EditIcon } from "@/utils/svgs";
import { BartenderInteface } from "@/interfaces/Bartender";
import { FiEdit2 } from "react-icons/fi";
import { formatNumber } from "@thdinc/hpf-shared";

interface Card {
  editStateFun: (id: string, name: string) => void;
  bartender: BartenderInteface;
  index: number;
  setModal: (modal: boolean) => void;
  setActiveId: (id: string) => void;
}
const BartCard: React.FC<Card> = ({
  editStateFun,
  bartender,
  index,
  setModal,
  setActiveId,
}) => {
  // const [optionVisible, setOptionVisible] = useState(false)
  const navigate = useNavigate();

  const handleInnerDivClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    // Prevent the click event from bubbling up to the parent div
    e.stopPropagation();
    setModal(true);
    setActiveId(bartender?.id as string);
  };
  return (
    <div
      onClick={() => {
        // navigate("/bartenders/schedule", { state: { id: props?.item?.id } });
      }}
      className="md:w-[380px] w-full     relative   bg-white  p-5  flex justify-start  items-start  rounded-xl "
      key={bartender?.id}
    >

      <img
        alt={defaultuser}
        src={
          bartender?.avatar?.includes("https://")
            ? bartender?.avatar
            : defaultuser
        }
        className="   border-2  object-cover min-w-[103px] sm:h-[103px] sm:w-[103px] w-28 h-24 rounded-full   self-center"
      />

      {/* Adjust px and py for padding as per your requirement */}
      {/* <div className="h-7  mx-4 rounded-t-md bg-orange-600 opacity-45">

      </div> */}
      {/* !props?.item?.is_admin */}

      {/* Your item content */}
      <div className="w-full  ml-3 ">
        <div className="flex justify-between items-center flex-wrap ">
          <h1 className="text-36 font-nunito font-semibold text-black md:text  text-wrap text-start ">
            {(bartender?.first_name + bartender?.last_name).length > 15
              ? (bartender?.first_name + "\n" + bartender?.last_name).slice(
                  0,
                  10
                ) + "..."
              : bartender?.first_name + "\n" + bartender?.last_name}
          </h1>
          {bartender?.is_admin && (
            <span className="inline-block rounded-full bg-[#3ACB6126] px-[14px] py-[6px] text-xs font-medium text-[#3ACB61]">
              Admin
            </span>
          )}
          {true && (
            <div className="  ">
              <div
                data-testid="delete-icon "
                className="p-2 bg-p-gray rounded-full font-bold flex gap-2"
              >
                {!bartender?.is_admin && (
                  <img
                    className="cursor-pointer"
                    src={deleteIcon}
                    onClick={handleInnerDivClick}
                  />
                )}
                <div
                className="cursor-pointer"
                  onClick={() =>
                    editStateFun(
                      bartender.id,
                      `${bartender.first_name} ${bartender.last_name}`
                    )
                  }
                >
                 <FiEdit2 size={14} />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="text-gray-500 text-sm">
          ${formatNumber(bartender.bartender_price / 100)}/h
        </div>
        <p className="text-xs text-primary-red font-semibold mt-2">
          {bartender?.guests_per_bartender} Guests
        </p>
        <div className="justify-start flex mt-2 ">
          <StarRating rating={5} index={index} />
        </div>
      </div>
    </div>
  );
};

export default BartCard;
